// This file is copied from https://github.com/googleapis/api-common-protos/blob/main/google/type/date.proto
// and modified to use the carmen package.

// Represents a whole or partial calendar date, e.g. a birthday. The time of day
// and time zone are either specified elsewhere or are not significant. The date
// is relative to the Proleptic Gregorian Calendar. This can represent:
//
// * A full date, with non-zero year, month and day values
// * A month and day value, with a zero year, e.g. an anniversary
// * A year on its own, with zero month and day values
// * A year and month value, with a zero day, e.g. a credit card expiration date
//
// Related types are [TimeOfDay][TimeOfDay] and `google.protobuf.Timestamp`.

// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/date.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_duration } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file proto/model/core/date.proto.
 */
export const file_proto_model_core_date = /*@__PURE__*/
  fileDesc("Chtwcm90by9tb2RlbC9jb3JlL2RhdGUucHJvdG8SBmNhcm1lbiIwCgREYXRlEgwKBHllYXIYASABKAUSDQoFbW9udGgYAiABKAUSCwoDZGF5GAMgASgFIo8BCglEYXRlUmFuZ2USIAoKc3RhcnRfZGF0ZRgBIAEoCzIMLmNhcm1lbi5EYXRlEiMKCGVuZF9kYXRlGAIgASgLMgwuY2FybWVuLkRhdGVIAIgBARIuCgtmbGV4aWJpbGl0eRgDIAEoCzIZLmdvb2dsZS5wcm90b2J1Zi5EdXJhdGlvbkILCglfZW5kX2RhdGVCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_google_protobuf_duration]);

/**
 * Describes the message carmen.Date.
 * Use `create(DateSchema)` to create a new message.
 */
export const DateSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_date, 0);

/**
 * Describes the message carmen.DateRange.
 * Use `create(DateRangeSchema)` to create a new message.
 */
export const DateRangeSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_date, 1);

